import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { PublicEventResolver } from '../../shared/resolvers/public-event.resolver';
import { WaitListResolver } from './waitList.resolver';

export function PurchaseHomeResolver(route: ActivatedRouteSnapshot) {
  const publicEventResolver = inject(PublicEventResolver);
  const waitListResolver = inject(WaitListResolver);

  return publicEventResolver.resolve(route).pipe(
    switchMap(() => waitListResolver.resolve()),
  );
}
